<template>
    <div class="flex-item learnworlds-align-left no-padding standalone" v-show="showFilters">
            <div class="lw-cols learnworlds-input-wrapper with-input-cols align-items-stretch  no-gutter one-row one-row-tl one-row-tp one-row-sl one-row-sp"  v-if="searchInputDisplay">
                <div class="col no-padding span_10_of_12 span_10_of_12-tl span_10_of_12-tp span_10_of_12-sl span_10_of_12-sp flex-item flexible">
                    <form @submit.prevent="">
                        <input class="full-height learnworlds-input learnworlds-input-small learnworlds-input-solid-white learnworlds-element"
                               :placeholder="$t('course.search_for_courses')"
                               type="text"
                               ref="searchInput"
                               @input="inputFilterApplied"
                               v-model="searchTermValue">
                    </form>
                </div>
                <div class="col no-padding span_2_of_12 span_2_of_12-tl span_2_of_12-tp span_2_of_12-sl span_2_of_12-sp flex-item flexible">
                    <button class="only-icon learnworlds-button learnworlds-element full-size learnworlds-button-solid-white learnworlds-button-small">
                        <span class="learnworlds-icon fas fa-search"></span>
                    </button>
                </div>
            </div>
            <div class="lw-filters mt-20 learnworlds-element">
                <template v-for="option in filtersConfig">
                    <div class="learnworlds-main-text learnworlds-main-text-small filter"
                         v-if="shouldBeDisplayed(option,'button')"
                         @click="primaryFilterApplied(option.filteringKey)"
                         :class="primaryFilterSelectedClass(option.filteringKey)"
                    >
                        {{option.translatedLabel}}
                    </div>

                    <div class="lw-filters-group mt-20" v-if="shouldBeDisplayed(option,'dropdown')">
                        <div class="lw-filters-group-heading learnworlds-overline-text">{{ option.translatedLabel }}</div>
                        <div class="learnworlds-main-text learnworlds-main-text-small filter"
                             v-for="item in option.dataSource"
                             :class="secondaryFilterSelectedClass(option.filteringKey, item.value)"
                             @click="secondaryFilterApplied(option.filteringKey,item.value)"
                        >
                            {{item.label}}
                        </div>
                    </div>
                </template>
            </div>
    </div>

</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";
    export default {
        name: "CourseCardsFiltersInSidebar",
        mixins: [ComponentTemplatesMixin],
        data () {
            return {
                filterAppearance : {
                    "byAll" : "button",
                    "byMyCourses" : "button",
                    "byNew" : "button",
                    "byPopular" : "button",
                    "byFree" : "button",
                    "byCategory" : "dropdown",
                    "byAuthor" : "dropdown",
                    "bySubscription" : "dropdown",
                    "byBundle" : "dropdown",
                    "bySearchTerm" : "input",
                }
            }
        },
        props: {
            filtersConfig : {
                type: Object,
            },
            disabledFilters: {
                type: Array,
            },
            searchTermValue : {
                type: String
            },
            selectedPrimaryFilter : {
                type:  String
            },
            selectedSecondaryFilter : {
                type:  String
            },
            showFilters: {
                type: Boolean
            },
            filtersWrapperNode: {
                type: Object
            }
        },
        computed: {
            searchInputDisplay () {
                return this.filtersConfig.find(option => option.filteringKey === "bySearchTerm" && this.shouldBeDisplayed(option,'input')) ? true : false;
            },
            renderedFilters () {
                return this.filtersConfig.filter(filter => this.shouldBeDisplayed(filter,'button'))
            }
        },
        methods : {
            $t (key) {
                return window.LWTranslate.get(key);
            },
            optionLabel (option) {
                return this.selectedPrimaryFilter === option.filteringKey && this.selectedSecondaryFilter ? option.dataSource.find(item => item.value === this.selectedSecondaryFilter).label : option.translatedLabel;
            },
            shouldBeDisplayed (option,type) {
                return  (   this.filterAppearance[option.filteringKey] === type || typeof this.filterAppearance[option.filteringKey] === "undefined" && type === 'button' ) &&
                            option.filterAvailable && this.filterEnabled(option.filteringKey);
            },
            primaryFilterApplied (primaryKey) {
                this.emitAction('primary-filter-applied',primaryKey);
            },
            inputFilterApplied (event) {
                this.secondaryFilterApplied('bySearchTerm',event.target.value);
            },
            secondaryFilterApplied (primaryKey,secondaryKey) {
                this.emitAction('secondary-filter-applied',{primaryKey,secondaryKey});
            },
            primaryFilterSelectedClass (filterKey) {
                return this.selectedPrimaryFilter === filterKey ? 'border-bottom' : 'text-only';
            },
            secondaryFilterSelectedClass (primaryFilteringKey, secondaryFilteringKey) {
                return (this.selectedPrimaryFilter === primaryFilteringKey && this.selectedSecondaryFilter === secondaryFilteringKey) ? 'border-bottom' : 'text-only';
            },
            filterEnabled (filterKey) {
                return this.disabledFilters && !this.disabledFilters.includes(filterKey);
            },
        },
        watch: {
            searchTermValue () {
                //had to force this, for some weird reason v-model wouldnt empty the input
                if (!this.searchTermValue) {
                    this.$refs.searchInput.value = "";
                } else if (this.$refs.searchInput.value !== this.searchTermValue){
                    this.$refs.searchInput.value = this.searchTermValue;
                }
            },
            showFilters: {
                immediate: true,
                handler (newVal) {
                    if (newVal) {
                        this.filtersWrapperNode.classList.add('fbasis-300');
                        this.filtersWrapperNode.classList.add('span_12_of_12-sp');
                    } else {
                        this.filtersWrapperNode.classList.remove('fbasis-300');
                        this.filtersWrapperNode.classList.remove('span_12_of_12-sp');
                    }
                }
            }
        }
    }
</script>
